import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import type { OnboardingSessionType, OnboardingUserType } from "@shared/types/OnboardingSession";

export class OnboardingSessionEntity extends BaseEntityClass {
  onboarding_user_type: OnboardingUserType;
  session_id: string;

  constructor(params: OnboardingSessionType) {
    super();
    this.type = "onboarding_session";
    this.entity_version = 2;
    this.session_id = params.session_id;
    this.onboarding_user_type = params.onboarding_user_type || null;
  }
}
